import { render, staticRenderFns } from "./BPJSPatientShow.vue?vue&type=template&id=1c3dea24&scoped=true"
import script from "./BPJSPatientShow.vue?vue&type=script&lang=js"
export * from "./BPJSPatientShow.vue?vue&type=script&lang=js"
import style0 from "./BPJSPatientShow.vue?vue&type=style&index=0&id=1c3dea24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dea24",
  null
  
)

export default component.exports